export default __webpack_public_path__ + "static/media/head04_ja_pc.15dac9c8.png";